export default __webpack_public_path__ + "static/media/bg03.b56f2f9c.svg";